/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'Navigation/AngleDown': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" fill-rule="evenodd" d="M27.911 10.529l-1.146-.97a.248.248 0 00-.35.03L16 21.953 5.586 9.589a.25.25 0 00-.352-.03l-1.146.97a.25.25 0 00-.029.352l11.176 13.264c.4.473 1.13.473 1.53 0L27.94 10.88a.25.25 0 00-.029-.352"/>'
  }
})
